"use client"

import { SiteDisclaimer } from "./site-disclaimer"

export function SiteLegalFooter() {
  return (
    <footer
      className="shrink-0 border-foreground/10 border-t bg-background px-4 py-3"
      data-testid="site-legal-footer"
    >
      <SiteDisclaimer className="w-full" />
    </footer>
  )
}
